import React from 'react'
import FirstColumn from "../item/first-column"
import LastColumn from "../item/last-column"
import GroupMoreButton from "./group-more-button/group-more-button"
import GroupHeaderArrow from "./arrow/group-header-arrow"
import FieldGlistGroup from "../../../../fields3/render/glist/glist-group";

const debug = false
// const debug = "GroupHeader"

export default function GroupHeader(props) {

    const field = props.module.fields.get(props.module.groupBy.value);

    const classes = Classes("group-header",{
        open    : !props.isCollapsed,
        closed  : props.isCollapsed,
        'sticky': props.module.titleSticky,
    })

    debug && console.log(debug, 'render', props)

    return (
        <div className={classes} onClick={props.onClick}>
            <div className="stick-left">
                <FirstColumn module={props.module} onClick={props.onClick}>
                    <GroupHeaderArrow module        = {props.module}
                                      isCollapsed   = {props.isCollapsed}/>
                </FirstColumn>

                <FieldGlistGroup field={field} glist={props.module} data={{
                    value       : props.group.groupByValue,
                    isCollapsed : props.isCollapsed,
                    counter     : props.group.models.length
                }} isCollapsed={props.isCollapsed} />

                {/*{field.gList.renderGroup({*/}
                {/*    value       : props.group.groupByValue,*/}
                {/*    isCollapsed : props.isCollapsed,*/}
                {/*    counter     : props.group.models.length*/}
                {/*}, props.module, props.isCollapsed)}*/}
                <GroupMoreButton isCollapsed        = {props.isCollapsed}
                                 onToggleCollapse   = {props.onClick}/>
            </div>

            {props.isCollapsed && <React.Fragment>
                <div className="line"/>
                <div className="stick-right">
                    <div className="counter">{props.group.models.length}</div>
                    <LastColumn module={props.module}/>
                </div>
            </React.Fragment>}
        </div>
    )
}
